export const environment = {
    type: 'dev',
    production: false,
    mock: true,
    apiurl: 'https://rapidgyan-dev.gyan-research.com/api/',
    gyanApiUrl: 'https://rapidgyan-dev.gyan-research.com/apigyan/',
    //appUrl: 'http://localhost:4200',
    //apiurl: 'http://localhost:4200/api/',
    //gyanApiUrl: 'http://localhost:4200/gyanApi/',
    appUrl: 'https://rapidgyan-dev.gyan-research.com',
    socketUrl: 'https://rapidgyan-dev.gyan-research.com/socket',
    azureAdB2CPolSignUpSignIn: 'https://gyandevad.b2clogin.com/gyandevad.onmicrosoft.com/B2C_1_rapidGyanSignIn',
    azureAdB2CPolResetPassword: 'https://gyandevad.b2clogin.com/gyandevad.onmicrosoft.com/B2C_1_rapidGyanResetPassword',
    azureAdB2CPolEditProfile: 'https://gyandevad.b2clogin.com/gyandevad.onmicrosoft.com/B2C_1_gyanEditProfile',
    azureAdB2CPolAuthorityDomain: 'gyandevad.b2clogin.com',
    azureAdB2CAuthClientId: 'd991f00a-44bc-408c-8637-eb99d35f7bb6',
    cookieDomain: '.gyan-research.com',
    cmsContentUrl: 'http://cms-dev.gyan-research.com',
    solrApiUrl: 'https://download-utility.gyan-research.com/solr/',
};
